import { connect } from 'react-redux';
import EfeitoDeContrato from './efeitoDeContrato';

export default connect()(EfeitoDeContrato);
